import {NgModule} from '@angular/core';
import {EcfmgService} from './ecfmg/ecfmg.service';
import {FellowshipOrPreceptorshipService} from './fellowship-or-preceptorship/fellowship-or-preceptorship.service';
import {InternshipService} from './internship/internship.service';
import {MedicalEducationService} from './medical/medical-education.service';
import {OtherEducationService} from './other/other-education.service';
import {PremedicalEducationService} from './premedical/premedical-education.service';
import {ResidencyService} from './residency/residency.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [
        EcfmgService,
        FellowshipOrPreceptorshipService,
        InternshipService,
        MedicalEducationService,
        OtherEducationService,
        PremedicalEducationService,
        ResidencyService
    ]
})
export class EducationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/education.module.ts